import { create } from 'zustand'

export type PreviewAdvanceMode = 'repeat' | 'bounce' | 'next' | 'jump'
export const previewSpeeds = [0.25, 0.5, 1, 2, 3] as const
export type PreviewSpeed = (typeof previewSpeeds)[number]

interface PreviewPlayerState {
  advanceMode: PreviewAdvanceMode
  speed: PreviewSpeed
  video: HTMLVideoElement | null
  setAdvanceMode: (mode: PreviewAdvanceMode) => void
  setSpeed: (speed: PreviewSpeed) => void
  setVideo: (video: HTMLVideoElement | null) => void
}

export const usePreviewPlayerStore = create<PreviewPlayerState>()((set) => ({
  advanceMode: 'repeat',
  speed: 1,
  video: null,
  setAdvanceMode: (advanceMode) => set({ advanceMode }),
  setSpeed: (speed) => set({ speed }),
  setVideo: (video) => set({ video }),
}))
